import PropTypes from 'prop-types'
import { Helmet as OrigHelmet } from 'react-helmet'
import i18n from 'i18next'

const Helmet = ({ metaData: { title, description, imageUrl } }) => (
  <OrigHelmet>
    <html lang={i18n.language} />
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={imageUrl} />
  </OrigHelmet>
)

Helmet.propTypes = {
  metaData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    imageUrl: PropTypes.string,
  }),
}

export default Helmet
